export const primaryOrderByProperty = 'updatedAt';

export const defaultOrderByProperty = 'id';

export const primaryOrderDirection = 'asc';

export const secundaryOrderDirection = 'desc';
